export default __webpack_public_path__ + "static/media/14_galeria.cddcaa9a.webp";